/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDeleteLeft } from "@fortawesome/free-solid-svg-icons";
import useSuggestedCandidates from "./useSuggestedCandidates";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import { Spinner } from "react-bootstrap";

export default (props) => {
  const {
    suggestedCandidates,
    showSearch,
    searchInputRef2,
    nextPage,
    onNextPageClick,
    onSearch,
    onSearchInputChange,
    onViewCandidateProfileClick,
    onAssignAssessmentClick,
    onShareAssessmentClick,
  } = useSuggestedCandidates(props);

  return (
    <>
      <div className="container">
        <div className="row no-gutters">
          <div className="col-md-12 col-lg-12 pt-0 pt-md-2 mb-4">
            <div className="row">
              <div className="col-md-8 pt-10">
                <h3 className="pt-10">
                  Showing {suggestedCandidates && suggestedCandidates.length}{" "}
                  Candidates
                </h3>
              </div>
              <div className="col-md-4">
                <div className="search py-2 justify-content-between align-items-center mr-md-4">
                  <div className="search-box input-group  align-items-center h-auto border rounded bg-grey">
                    <input
                      type="text"
                      className="form-control border-0 bg-transparent"
                      placeholder="Search"
                      onChange={(e) => onSearchInputChange(e)}
                      ref={searchInputRef2}
                      style={{ height: "46px" }}
                    />
                    <div className="input-group-append">
                      {showSearch ? (
                        <button
                          className="btn p-2"
                          type="button"
                          onClick={onSearch}
                        >
                          <FontAwesomeIcon
                            icon={faDeleteLeft}
                            className="ml-2"
                          />
                        </button>
                      ) : (
                        <button className="btn p-2" type="button">
                          <img
                            src="../assets/images/search-icon.png"
                            alt="search"
                          />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12">
            {suggestedCandidates &&
              Array.isArray(suggestedCandidates) &&
              suggestedCandidates.length ? (
              <div className="job-listing">
                <div className="row">
                  {Array.isArray(suggestedCandidates) &&
                    suggestedCandidates.map((item, index) => (
                      <>
                        <div
                          className="col-lg-6  mb-4"
                          key={index}
                        // ref={setLastElement}
                        >
                          <div
                            className="job-box p-3 d-flex h-100 flex-column my-0 bg-white border position-relative rounded-lg"
                            style={{
                              boxShadow:
                                "0px 1px 2px rgba(122, 134, 154, 0.25)",
                            }}
                          >
                            <div className="d-flex mb-3 align-items-start">
                              <img
                                src={
                                  item?.user_details?.user_meta_info
                                    ?.profile_image
                                    ? item?.user_details?.user_meta_info
                                      ?.profile_image
                                    : "/assets/images/dummy.png"
                                }
                                alt="candidate"
                                className="mr-3 border-radius-10"
                                style={{
                                  width: "70px",
                                  height: "60px",
                                  objectFit: "cover",
                                }}
                              />
                              <div className="job-info">
                                <h3
                                  className="font-weight-bold mb-1 text-capitalize cursor-pointer text-primary"
                                  onClick={() =>
                                    onViewCandidateProfileClick(
                                      item?.user_details &&
                                      item.user_details?.hash_id
                                    )
                                  }
                                >
                                  {item?.user_details &&
                                    item.user_details?.full_name}
                                </h3>
                                <p className="text-grey-4">{item.headline}</p>
                              </div>
                              <div className="ml-auto">
                                <button
                                  className="bg-transparent border-0"
                                  onClick={() =>
                                    onShareAssessmentClick(
                                      item?.user_details &&
                                      item?.user_details.hash_id
                                    )
                                  }
                                  title="Share"
                                >
                                  <img
                                    src="/assets/images/share-icon.svg"
                                    alt="share"
                                  />
                                </button>
                              </div>
                            </div>

                            <ul className="d-flex align-items-center">
                              <li className="mr-3 d-flex align-items-center">
                                <span>
                                  <img
                                    src="/assets/images/money-icon-grey.svg"
                                    alt="money"
                                  />
                                </span>
                                <span className="text-dark-4 fs-smallest">
                                  {item?.current_salary
                                    ? item?.current_salary
                                    : "NA"}
                                </span>
                              </li>
                              <li className="mr-3 d-flex align-items-center">
                                <span>
                                  <img
                                    src="/assets/images/location-grey.svg"
                                    alt="money"
                                  />
                                </span>
                                <span className="text-dark-4 fs-smallest">
                                  {item?.state_name ? item?.state_name : "NA"}
                                </span>
                              </li>

                              <li className="d-flex align-items-center">
                                <span>
                                  <img
                                    src="/assets/images/suitcase-grey.svg"
                                    alt="money"
                                  />
                                </span>
                                <span className="text-dark-4 fs-smallest">
                                  {item?.current_salary
                                    ? item?.current_salary
                                    : "NA"}
                                </span>
                              </li>
                            </ul>

                            {Array.isArray(item?.skills && item.skills) &&
                              item?.skills &&
                              item.skills.length > 0 ? (
                              <div className="d-flex align-items-center fs-smallest flex-wrap  mb-3">
                                <p className="mb-0 mr-2 text-capitalize">
                                  <span className="font-weight-medium">
                                    Skills:{" "}
                                  </span>

                                  {Array.isArray(item?.skills) &&
                                    item?.skills.map((skill, index) => (
                                      <span
                                        key={index}
                                        className="skill bg-grey px-2 d-inline-block rounded-sm mr-2 my-1 py-1"
                                      >
                                        {skill?.skill_name}
                                      </span>
                                    ))}
                                </p>
                              </div>
                            ) : null}

                            <div className="job-bottom d-flex align-items-center justify-content-between mt-auto pt-3">
                              <span className="text-muted fs-smallest mr-2">
                                Suggested Profile
                              </span>

                              <div className="d-flex ml-auto fs-smallest text-uppercase">
                                <button
                                  className="text-primary border-0 bg-transparent ml-2 font-weight-semi"
                                  onClick={() =>
                                    onAssignAssessmentClick(item && item?.user)
                                  }
                                >
                                  Assign Assessment
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ))}
                </div>
              </div>
            ) : (
              <div className="text-white p-3 border-6 d-flex align-items-center justify-content-center mb-2 mw-50 mx-auto">
                <p className="mb-0">
                  <img
                    src="/assets/images/no-suggested.png"
                    alt="no-suggested candidates"
                  />
                </p>
              </div>
            )}
          </div>
        </div>

        {nextPage &&
          suggestedCandidates &&
          Array.isArray(suggestedCandidates) &&
          suggestedCandidates.length && (
            <button
              className="btn btn-secondary py-2 "
              onClick={() => onNextPageClick()}
            >
              Load More
            </button>
          )}
      </div>
    </>
  );
};
